import React, {
    useState
} from "react";
import axios from "axios";
import RegistroObsequios from "../promotions/RegistroObsequios";
import AccessorySaleDetailModal from "../accessories/AccessorySaleDetailModal";
import { FiDownload, FiEdit3, FiX, FiVideo } from "react-icons/fi";
import { useAuth } from "../../provider/authProvider";
import moment from "moment-timezone";
import "moment/locale/es";

moment.locale("es");

const TableCredito = (props) => {
    const { rol } = useAuth();
    const {
        sedeName,
        cat,
        subCat,
        segment,
        description,
        phone,
        phonePrice,
        name,
        paternalSur,
        maternalSur,
        fm,
        fmAmount,
        imei,
        dni,
        email,
        phoneNumber,
        initial,
        cashAmount,
        onlinePay,
        onlineAmount,
        paymentDetails,
        saleMeta,
        createDate,
        applicant,
        applicantName,
        applicantPaternalSur,
        userName,
        num_fee_paid: numFeePaid,
        warranty_state,
        initialValidationVideoUrl,
        electronicDocumentId,
        electronicDocumentNumber,
        electronicDocumentType,
        electronicDocuments,
    } = props.data;

    const foreignCountryName = (() => {
        try {
            const meta = typeof saleMeta === "string" ? JSON.parse(saleMeta) : saleMeta;
            return meta?.country_iso2 && String(meta.country_iso2).toLowerCase() !== "pe"
                ? String(meta.country_name || meta.country_iso2).trim() : "";
        } catch (_) { return ""; }
    })();

    // NUEVO: props para edición, eliminación y descarga del comprobante.
    const { onEdit, onDelete, onViewInitialVideo, onDownloadTicket, canEdit = false } = props;
    const [ticketDownloading, setTicketDownloading] = useState(false);
    const [accessoryDetail, setAccessoryDetail] = useState(null);
    const [accessoryLoading, setAccessoryLoading] = useState(false);
    const [accessoryError, setAccessoryError] = useState("");
    const parsedSaleMeta = (() => { try { return typeof saleMeta === 'string' ? JSON.parse(saleMeta) : (saleMeta || {}); } catch { return {}; } })();
    // Registros antiguos o consultas que no incluyen sale_meta conservan
    // la descripción persistida "VENTA DE N ACCESORIOS".
    const isAccessoryRegister = Number(cat) === 2 && Number(subCat) === 3;
    const accessorySaleId = Number(parsedSaleMeta.accessorySaleId || parsedSaleMeta.accessory_sale_id || 0);
    const accessoryItemsCount = Number(parsedSaleMeta.itemsCount || parsedSaleMeta.items_count || 0);
    const descriptionCount = /^VENTA\s+DE\s+(\d+)\s+ACCESORIOS\s*$/i.exec(String(description || '').trim());
    const showAccessoryDetail = isAccessoryRegister && (accessorySaleId > 0 || Number(props.data?.id) > 0);
    const openAccessoryDetail = async () => {
        setAccessoryError(""); setAccessoryLoading(true); setAccessoryDetail(null);
        try {
            const base = (process.env.REACT_APP_API || '/api').replace(/\/$/, '');
            const endpoint = Number(props.data?.id) > 0
                ? `${base}/accessory-sales/by-register/${Number(props.data.id)}`
                : `${base}/accessory-sales/${accessorySaleId}`;
            const response = await axios.get(endpoint, { withCredentials: true });
            if (!response.data?.success) throw new Error(response.data?.message || 'No se pudo consultar la venta.');
            setAccessoryDetail(response.data.data);
        } catch (error) { setAccessoryError(error.response?.data?.message || error.message || 'Error de consulta.'); }
        finally { setAccessoryLoading(false); }
    };

    const normalizedElectronicDocuments = (() => {
        if (Array.isArray(electronicDocuments)) return electronicDocuments;
        if (typeof electronicDocuments === "string") {
            try {
                const parsed = JSON.parse(electronicDocuments);
                return Array.isArray(parsed) ? parsed : [];
            } catch (_) { return []; }
        }
        return [];
    })();
    const receiptButtons = normalizedElectronicDocuments.length
        ? normalizedElectronicDocuments
        : (electronicDocumentId ? [{ id: electronicDocumentId, fullNumber: electronicDocumentNumber, documentType: electronicDocumentType, documentRole: "STANDARD" }] : []);
    const canDownloadTicket = receiptButtons.length > 0 && typeof onDownloadTicket === "function";

    // El botón conserva la descarga del ticket PDF, pero muestra el tipo real
    // de comprobante asociado a la venta para evitar confusión al usuario.
    const documentButtonLabel = (() => {
        const documentType = String(electronicDocumentType || "").trim().toUpperCase();

        if (documentType === "01") return "Factura";
        if (documentType === "03") return "Boleta";
        if (documentType === "NV" || documentType === "NOTA_VENTA") return "Nota de Venta";

        // Fallback defensivo para registros antiguos o datos incompletos.
        return "Comprobante";
    })();

    const handleDownloadTicket = async (document = null) => {
        if (!canDownloadTicket || ticketDownloading) return;
        try {
            setTicketDownloading(true);
            await onDownloadTicket(props.data, document);
        } finally {
            setTicketDownloading(false);
        }
    };

    const isWarrantyMuted = [2, 3].includes(Number(warranty_state || 0));

    // const isCuotaPago = Number(cat) === 2 && Number(subCat) === 2 && [1, 2].includes(Number(segment));
    const isCuotaPago =
        Number(cat) === 2 &&
        Number(subCat) === 2 &&
        [1, 2, 4, 5].includes(Number(segment));
    const isFmPago = Number(cat) === 2 && Number(subCat) === 6; // FM MovilesPay y payjoy
    const showNumCuotas = isCuotaPago || isFmPago;

    const numCuotasLabel = isFmPago ? "Número Cuota(s)" : "Número Cuota(s)";

    const catSet =
        cat == "1"
            ? "Crédito"
            : cat == "2"
                ? "Contado"
                : cat == "3"
                    ? "Egreso"
                    : cat == "4"
                        ? "Ingreso"
                        : cat == "5"
                            ? "Retiro"
                            : "";

    const subCatSet =
        cat == "1" && subCat == "1"
            ? "Celular"
            : cat == "2" && subCat == "1"
                ? "Celular"
                : cat == "2" && subCat == "2"
                    ? "Cuota"
                    : cat == "2" && subCat == "3"
                        ? "Accesorios"
                        : cat == "2" && subCat == "4"
                            ? "Formateo"
                            : cat == "2" && subCat == "5"
                                ? "Chip"
                                : cat == "2" && subCat == "6"
                                    ? "FM"
                                    : cat == "3" && subCat == "1"
                                        ? "Pilas"
                                        : cat == "3" && subCat == "2"
                                            ? "Combustible"
                                            : cat == "3" && subCat == "3"
                                                ? "PH"
                                                : cat == "3" && subCat == "4"
                                                    ? "Agua"
                                                    : cat == "3" && subCat == "5"
                                                        ? "Incienso"
                                                        : cat == "3" && subCat == "6"
                                                            ? "Bolsa"
                                                            : cat == "3" && subCat == "7"
                                                                ? "Alquiler"
                                                                : cat == "3" && subCat == "8"
                                                                    ? "Limpieza"
                                                                    : cat == "3" && subCat == "9"
                                                                        ? "Papel Bond"
                                                                        : cat == "3" && subCat == "10"
                                                                            ? "Otros"
                                                                            : cat == "4" && subCat == "1"
                                                                                ? "Efectivo"
                                                                                : cat == "5" && subCat == "1"
                                                                                    ? "Efectivo"
                                                                                    : "";

    const isCrediSmartCredit =
        Number(cat) === 1 && Number(subCat) === 1 && Number(segment) === 4;
    const isMovilProContado =
        Number(cat) === 2 && Number(subCat) === 1 && Number(segment) === 4;
    const isCrediSmartFm =
        Number(cat) === 2 &&
        [2, 6].includes(Number(subCat)) &&
        Number(segment) === 4;
    const isAloCreditContext =
        Number(segment) === 5 &&
        ((Number(cat) === 1 && Number(subCat) === 1) ||
            (Number(cat) === 2 && [2, 6].includes(Number(subCat))));

    const segmentSet =
        segment == "1"
            ? "Payjoy"
            : segment == "2"
                ? "MovilesPay"
                : segment == "3"
                    ? "Efectiva"
                    : segment == "4"
                        ? isMovilProContado
                            ? "MovilPro"
                            : isCrediSmartCredit || isCrediSmartFm
                                ? "CrediSmart"
                                : "MovilPro"
                        : segment == "5" && isAloCreditContext
                            ? "Alo Credit"
                            : "MovilPro";

    const createDateSet = moment
        .utc(createDate)
        .tz("America/Lima")
        .format("dddd DD [de] MMMM [del] YYYY hh:mm:ss A");

    const fmSet = fm == "1" ? "Si" : "No";
    const onlinePaySet =
        onlinePay == "1"
            ? "Yape"
            : onlinePay == "2"
                ? "Tarjeta"
                : onlinePay == "3"
                    ? "Transferencia"
                    : onlinePay == "4"
                        ? "Culqi POS"
                        : onlinePay == "5"
                            ? "Culqi Yape"
                            : onlinePay == "6"
                                ? "Culqi Tarjeta"
                                : "-";
    const paymentMethodLabels = {"0":"Efectivo","1":"Yape","2":"Tarjeta","3":"Transferencia","4":"Culqi POS","5":"Culqi Yape","6":"Culqi Tarjeta"};
    const parsePaymentDetails = (value) => {
        if (Array.isArray(value)) return value;
        if (!value) return [];
        try { const parsed=JSON.parse(value); return Array.isArray(parsed)?parsed:[]; } catch (_) { return []; }
    };
    const paymentRows = parsePaymentDetails(paymentDetails).map(p=>({method:String(p?.method??""),amount:Number(p?.amount||0)})).filter(p=>p.method&&p.amount>0);
    const hasDetailedPayments = paymentRows.length>0;
    const formatRegisterMoney = value => `S/. ${Number(value||0).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})}`;

    const isRescheduledRegister = String(parsedSaleMeta?.operation || "").toUpperCase() === "RESCHEDULE";

    const setApplicant = cat == "4" ? "Depositante" : "Solicitante";

    const classNameSet =
        cat == "1" && subCat == "1" && segment == "1"
            ? "1"
            : cat == "1" && subCat == "1" && segment == "2"
                ? "2"
                : cat == "1" && subCat == "1" && segment == "3"
                    ? "3"
                    : cat == "1" && subCat == "1" && segment == "4"
                        ? "20"
                        : cat == "1" && subCat == "1" && segment == "5"
                            ? "30"
                            : cat == "2" && subCat == "1"
                                ? "4"
                                : cat == "2" && subCat == "2" && segment == "1"
                                    ? "6"
                                    : cat == "2" && subCat == "2" && segment == "4"
                                        ? "21"
                                        : cat == "2" && subCat == "2" && segment == "2"
                                            ? "5"
                                            : cat == "2" && subCat == "2" && segment == "5"
                                                ? "31"
                                                : cat == "2" && subCat == "3"
                                                    ? "8"
                                                    : cat == "2" && subCat == "4"
                                                        ? "7"
                                                        : cat == "2" && subCat == "5"
                                                            ? "9"
                                                            : cat == "2" && subCat == "6" && segment == "1"
                                                                ? "6"
                                                                : cat == "2" && subCat == "6" && segment == "2"
                                                                    ? "5"
                                                                    : cat == "2" && subCat == "6" && segment == "5"
                                                                        ? "31"
                                                                        : cat == "2" && subCat == "6" && segment == "3"
                                                                            ? "21"
                                                                            : cat == "3" &&
                                                                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(
                                                                                    subCat,
                                                                                )
                                                                                ? "10"
                                                                                : cat == "4" && subCat == "1"
                                                                                    ? "12"
                                                                                    : cat == "5" && subCat == "1"
                                                                                        ? "13"
                                                                                        : "";

    let setSedeName = sedeName && sedeName.split(" ").slice(1).join(" ");

    // Editar: rol 1 y 3
    const canEditThisRow = canEdit && (rol === "1" || rol === "3");
    // Eliminar: SOLO rol 1
    // Las ventas de celulares y accesorios se anulan mediante su flujo de
    // nota de crédito; no se ofrece eliminación directa desde Registros.
    const isProtectedSale =
        (Number(cat) === 1 && Number(subCat) === 1) || // Celular a crédito
        (Number(cat) === 2 && [1, 3].includes(Number(subCat))); // Celular / accesorios al contado
    const canDeleteThisRow = canEdit && rol === "1" && !isProtectedSale;
    // const canViewInitialVideo = Boolean(initialValidationVideoUrl) && Number(cat) === 1 && Number(subCat) === 1;

    const isRetiro = Number(cat) === 5 && Number(subCat) === 1;
    const canSeeRetiro = rol === "1" || rol === "3";

    const canViewInitialVideo =
        ["1", "5"].includes(String(rol)) &&
        Boolean(props.data?.initialValidationVideoUrl);

    if (isRetiro && !canSeeRetiro) {
        return <></>;
    } else {
        return (
            <div
                className={`registerTable registerTable${classNameSet} ${isWarrantyMuted ? "registerWarrantyMuted" : ""
                    }`}
            >
                <table>
                    <caption>
                        <div className="registerCaption">
                            <span className="registerCaption-date">{foreignCountryName ? `País: ${foreignCountryName} · ` : ""}{createDateSet}</span>

                            {(isRescheduledRegister || canDownloadTicket || canEditThisRow || canDeleteThisRow || canViewInitialVideo || props.data?.id) && (
                                <div className="registerCaption-actions">
                                    {props.data?.id && <RegistroObsequios registerId={props.data.id} role={rol} />}
                                    {isRescheduledRegister && <span className="registerRescheduleBadge">↻ REPROGRAMACIÓN</span>}
                                    {canDownloadTicket && receiptButtons.map((doc, docIndex) => {
                                        const type = String(doc?.documentType || electronicDocumentType || "").toUpperCase();
                                        const role = String(doc?.documentRole || "STANDARD").toUpperCase();
                                        const typeLabel = type === "01" ? "Factura" : type === "03" ? "Boleta" : type === "NV" ? "Nota de Venta" : documentButtonLabel;
                                        const roleLabel = role === "ADVANCE" ? "Anticipo" : role === "FINAL" ? "Final" : typeLabel;
                                        return (
                                            <button
                                                key={doc?.id || docIndex}
                                                type="button"
                                                className="btnTicketRegister"
                                                title={`Descargar ${roleLabel}${doc?.fullNumber ? ` · ${doc.fullNumber}` : ""}`}
                                                onClick={() => handleDownloadTicket(doc)}
                                                disabled={ticketDownloading}
                                            >
                                                <FiDownload />
                                                <span>{ticketDownloading ? "Descargando..." : (receiptButtons.length > 1 ? roleLabel : typeLabel)}</span>
                                            </button>
                                        );
                                    })}

                                    {canEditThisRow && (
                                        <button
                                            type="button"
                                            className="btnEditRegister"
                                            title="Editar registro"
                                            onClick={onEdit}
                                        >
                                            <FiEdit3 />
                                        </button>
                                    )}

                                    {canViewInitialVideo && (
                                        <button
                                            type="button"
                                            className="btnInitialVideoRegister"
                                            title="Ver video de validación de inicial"
                                            onClick={onViewInitialVideo}
                                        >
                                            <FiVideo />
                                        </button>
                                    )}

                                    {canDeleteThisRow && (
                                        <button
                                            type="button"
                                            className="btnDeleteRegister"
                                            title="Eliminar registro"
                                            onClick={onDelete}
                                        >
                                            <FiX />
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </caption>

                    <thead>
                        <tr
                            className={
                                Number(warranty_state) === 2 || Number(warranty_state) === 3
                                    ? "registerWarrantyMuted"
                                    : ""
                            }
                        >
                            <th>Sede</th>
                            <th>Tipo de Registro</th>
                            <th>Tipo de Producto</th>
                            {segment && <th>Fuente</th>}
                            {userName && rol !== "3" && <th>Seller</th>}
                            {description && <th>Descripción</th>}
                            {phone && <th>Equipo Celular</th>}
                            {parseFloat(phonePrice) > 0 && <th>Precio</th>}
                            {name && <th>Nombre</th>}
                            {paternalSur && <th>Apellido 1</th>}
                            {maternalSur && <th>Apellido 2</th>}
                            {fm && fm !== "0" && <th>FM</th>}
                            {parseFloat(fmAmount) > 0 && <th>Monto FM</th>}
                            {imei && <th>IMEI</th>}
                            {dni && <th>DNI</th>}
                            {email && <th>EMAIL</th>}
                            {phoneNumber && <th>Celular</th>}
                            {parseFloat(initial) > 0 && <th>Inicial</th>}
                            {/* {isCuotaPago && <th>Número Cuota(s)</th>} */}
                            {showNumCuotas && <th>{numCuotasLabel}</th>}
                            {hasDetailedPayments ? paymentRows.map((p,idx)=><th key={`pay-h-${p.method}-${idx}`}>Monto {paymentMethodLabels[p.method]||"Pago"}</th>) : <>
                                {parseFloat(cashAmount) > 0 && <th>Monto Efectivo</th>}
                                {parseFloat(onlineAmount) > 0 && <th>Monto {onlinePaySet !== "-" ? onlinePaySet : "Online"}</th>}
                            </>}
                            {applicant && <th>{setApplicant}</th>}
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>
                                <strong>{setSedeName || sedeName}</strong>
                            </td>
                            <td className="cat">{catSet}</td>
                            <td className="subCat" width="5%">
                                <strong>{subCatSet}</strong>
                            </td>

                            {segment && <td>{segmentSet}</td>}
                            {userName && rol !== "3" && <td width="7%">{userName}</td>}
                            {description && <td><span>{description}</span>{showAccessoryDetail && <button type="button" onClick={openAccessoryDetail} disabled={accessoryLoading} style={{marginLeft:8,padding:'4px 9px',border:'1px solid #7c3aed',borderRadius:6,background:'#faf5ff',color:'#6d28d9',cursor:'pointer',fontWeight:600}}>{accessoryLoading ? 'Cargando...' : 'Ver detalle'}</button>}{accessoryError && <small role="alert" style={{display:'block',color:'#b91c1c'}}>{accessoryError}</small>}{accessoryDetail && <AccessorySaleDetailModal detail={accessoryDetail} registerId={props.data.id} onClose={() => setAccessoryDetail(null)} />}</td>}
                            {phone && (
                                <td width="11%" className="tableWidth phoneNameTd">
                                    {phone}
                                </td>
                            )}
                            {parseFloat(phonePrice) > 0 && (
                                <td width="6%" className="withSymbol">
                                    S/. {parseFloat(phonePrice).toFixed(2)}
                                </td>
                            )}
                            {name && <td>{name}</td>}
                            {paternalSur && <td>{paternalSur}</td>}
                            {maternalSur && <td>{maternalSur}</td>}
                            {fm && fm !== "0" && <td width="3%">{fmSet}</td>}
                            {parseFloat(fmAmount) > 0 && (
                                <td width="6.2%" className="withSymbol">
                                    S/. {parseFloat(fmAmount).toFixed(2)}
                                </td>
                            )}
                            {imei && <td width="6.5%">{imei}</td>}
                            {dni && <td>{dni}</td>}
                            {email && <td width="10%">{email}</td>}
                            {phoneNumber && <td>{phoneNumber}</td>}
                            {parseFloat(initial) > 0 && <td>{initial}%</td>}

                            {showNumCuotas && (
                                <td width="6%">
                                    {Number(numFeePaid || 0) > 1
                                        ? `${Number(numFeePaid)}`
                                        : Number(numFeePaid || 0) === 1
                                            ? numFeePaid
                                            : "-"}
                                </td>
                            )}

                            {hasDetailedPayments ? paymentRows.map((p,idx)=>(
                                <td key={`pay-v-${p.method}-${idx}`} width="6%" className="withSymbol">{formatRegisterMoney(p.amount)}</td>
                            )) : <>
                                {parseFloat(cashAmount) > 0 && <td width="6%" className="withSymbol">{formatRegisterMoney(cashAmount)}</td>}
                                {parseFloat(onlineAmount) > 0 && <td width="6%" className="withSymbol">{formatRegisterMoney(onlineAmount)}</td>}
                            </>}
                            {applicant && (
                                <td>{applicantName + " " + applicantPaternalSur}</td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
};

export default TableCredito;
